import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from "@angular/core";
import * as _ from "lodash";
import {TaskRelationModel} from "../../../../tasks/models/task-relation.model";
import {isBlockedRelationType} from "../../../../tasks/utils/task-relations.util";

require('./task-relations-indicator.scss');
@Component({
  standalone: false,
  selector: 'app-task-relations-indicator',
  templateUrl: './task-relations-indicator.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaskRelationsIndicatorComponent implements OnChanges {

  @Input() relations: TaskRelationModel[];
  @Output() onClick = new EventEmitter<MouseEvent>();

  public blockedCount: number = 0;
  public relatedCount: number = 0;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.relations) {
      const relations = _.uniqBy(this.relations || [], relation => `${relation.type}::${relation.relatedTaskId}`);
      const blockedRelations = _.filter(relations, relation => isBlockedRelationType(relation.type));
      const otherRelations = _.filter(relations, relation => !isBlockedRelationType(relation.type));
      this.blockedCount = blockedRelations.length;
      this.relatedCount = otherRelations.length;
    }
  }

  onIndicatorClick(event: MouseEvent) {
    if (!this.blockedCount && !this.relatedCount) {
      return;
    }
    event.stopPropagation();
    this.onClick.emit(event);
  }
}
